import React, { useEffect, useState, useRef } from 'react';
import { __ } from '../../Lang.js'; // Add translation function import
import InternalNav from '../common/InternalNav.jsx';
import VideoTopNavigation from './VideoTopNavigtation.jsx';
import PlayerSection from './PlayerSection.jsx';
import VideoControlsPanel from './VideoControlsPanel.jsx';
import RelatedRecommendedVideos from './RelatedRecommendedVideos.jsx';
import PlaylistModal from './PlaylistModal.jsx';
import { Box, Typography } from '@mui/material';
import { MusicVideo as MusicVideoIcon, OndemandVideo as OndemandVideoIcon } from '@mui/icons-material';
import { Grid } from '@mui/material';
import PersonalUseBadge from '../common/PersonalUseBadge.jsx';


const ShowVideoOrPlaylist = (props) => {

  const playlist = props.playlist;
  const playlistAcl = props.playlistAcl || {};

  const [showOverlay, setShowOverlay] = useState(false);
  const [countdown, setCountdown] = useState(3);

  const videoData = props.videoData;
  const video = videoData.video;
  const navigate = props.navigate ?? useNavigate();

  const {
    restricted,
    block_message,
    usage_type_link,
    usage_type_message,
    related_videos: relatedVideos,
    recommended_videos: recommendedVideos,
    mylist_already_exists,
    related_videos_display_title,
    logged_in,
    is_seminar_leader,
    svod_subscription,
    cta_kind,
    app_link,
    app_button_title,
  } = videoData;

  const isRecommended = location.state?.activeTab === 'recommended';
  const [hidePersonalBanner, setHidePersonalBanner] = useState(false);
  // Check URL to determine if we're in a mylist context
  const urlParams = new URLSearchParams(location.search);
  const isMylistContext = urlParams.has('mylist');
  const isInPlaylistContext = urlParams.has('list') || urlParams.has('mylist') || playlist?.uniqid;

  // Get all playlists/mylists the video belongs to from API
  const videoPlaylists = props.videoData.video?.playlists || [];
  const videoMylists = props.videoData.video?.mylists || [];

  // Ensure current playlist/mylist is included (if not already in the list)
  const currentPlaylistInList = playlist && !isMylistContext && !videoPlaylists.some(p => p?.uniqid === playlist.uniqid);
  const currentMylistInList = playlist && isMylistContext && !videoMylists.some(m => m?.uniqid === playlist.uniqid);

  const playlists = (currentPlaylistInList ? [playlist, ...videoPlaylists] : videoPlaylists).filter(Boolean);
  const mylists = (currentMylistInList ? [playlist, ...videoMylists] : videoMylists).filter(Boolean);

  const autoplayVideos = (isRecommended ? recommendedVideos : relatedVideos);
  const autoplayIndex = autoplayVideos?.findIndex(v => (v.uniqid === video?.uniqid)) ?? 0;
  const playlistVideos = playlist?.videos || [];
  const playlistVideosIndex = playlistVideos.findIndex(pl => pl.uniqid === video?.uniqid) ?? -1;

  // next video is playlist video, otherwise from autoplay list
  const nextVideo = playlistVideosIndex !== -1 ? playlistVideos?.[(playlistVideosIndex + 1) % (playlistVideos.length || 1)]  : autoplayVideos?.[(autoplayIndex + 1) % (autoplayVideos?.length || 1)]
  const currentPageInit = autoplayIndex > 0 ? autoplayIndex : 0;

  const [currentPage, setCurrentPage] = useState(currentPageInit);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showMore, setShowMore] = useState(false);
  const [autoplay, setAutoplay] = useState(() => localStorage.getItem('autoplay') === 'true');
  const [shuffle, setShuffle] = useState(() => localStorage.getItem('shuffle') === 'true');
  const [repeat, setRepeat] = useState(() => localStorage.getItem('repeat') === 'true');
  const [showPlaylistModal, setShowPlaylistModal] = useState(false);
  const [playlistFeedback, setPlaylistFeedback] = useState('')


  const [activeTab, setActiveTab] = useState(() => {
    // Only show 'recommended' tab when in playlist/mylist URL context
    const urlParams = new URLSearchParams(location.search);
    if (urlParams.has('list') || urlParams.has('mylist')) {
      return 'recommended';
    }
    return 'related';
  });

  useEffect(() => {
    localStorage.setItem('autoplay', autoplay);
  }, [autoplay]);

  useEffect(() => {
    localStorage.setItem('shuffle', shuffle);
  }, [shuffle]);

  useEffect(() => {
    localStorage.setItem('repeat', repeat);
  }, [repeat]);

  useEffect(() => {
    const localSetting = localStorage.getItem('autoplay');

    if (localSetting !== null) {
      setAutoplay(localSetting === 'true');
    } else if (videoData.video?.autoplay_on !== undefined) {
      setAutoplay(videoData.video.autoplay_on);
      localStorage.setItem('autoplay', videoData.video.autoplay_on);
    }

  }, [videoData]);

  const description = video?.description || '';
  const truncatedDescription = description.length > 200 && !showMore
    ? description.substring(0, 200) + '...'
    : description;

  const isAudio = video.asset_type?.toLowerCase() === 'audio';
  const isVideo = video.asset_type?.toLowerCase() === 'video';
  const isPublic = video.usage_type?.toLowerCase() === 'public';
  const isMinister = video.usage_type?.toLowerCase() === 'minister' || video.usage_type?.toLowerCase() === 'minster or initiate';
  const isInitiate = video.usage_type?.toLowerCase() === 'initiate' || video.usage_type?.toLowerCase() === 'minster or initiate';
  const isSatSubscriber = video.usage_type?.toLowerCase() === 'sat';
  const isDiscourse = video.usage_type?.toLowerCase() === 'discourse';
  const isPersonal = video.usage_type?.toLowerCase() === 'personal';
  const isPremium = video.access === 'svod' || video.visibility === 'SVOD Only';

  // Build every playlist client-side from our refs (canonical uniqid) rather than
  // loading by Brightcove playlist/video IDs. This keeps raw Brightcove video IDs off
  // the page (access control is Laravel-only).
  const usePlaylistOverride = Array.isArray(playlist?.videos) && playlist.videos.length > 0;

  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div className="video-wrapper">
      <div className="video-background-overlay"></div>


        {isMobile ? (
          <>
            <div className="video-mobile-breadcrumbs">
              <VideoTopNavigation
                nextVideo={nextVideo}
                relatedVideos={relatedVideos}
                autoplayIndex={autoplayIndex}
                playlist={playlist}
                currentVideo={video}
              />
            </div>
            <div className="hero__mobile-nav">
              <InternalNav isLoggedIn={logged_in === true} />
            </div>
          </>
        ) : (
          <>
            <div className="hero__nav-row">
              <a href="/app/twi" className="video-breadcrumb-link hero__twi-link">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{ marginRight: '6px', verticalAlign: 'middle' }}
                >
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
                {__('Back to TWI')}
              </a>
              <div className="hero__sidebar">
                <InternalNav isLoggedIn={logged_in === true} />
              </div>
            </div>
            <VideoTopNavigation
              nextVideo={nextVideo}
              relatedVideos={relatedVideos}
              autoplayIndex={autoplayIndex}
              playlist={playlist}
              currentVideo={video}
            />
          </>
        )}
        {playlist?.uniqid &&
        /* two column grid for playlist title and icon */
        <Grid className="group-header" alignItems="center" container mb={2} mt={2}>
          <Grid item xs={12} sm={8} md={9}>
          <Box>
            <a href={playlist.is_custom ? `/app/twi/mylist/${playlist.uniqid}` : playlist.permalinks?.web} className="video-group-title-link">
              <Typography variant="h1" component="h1" className="video-group-title">
                {playlist.name ?? playlist.title}
              </Typography>
            </a>
          </Box>
          </Grid>
          <Grid item xs={12} sm={4} md={3}>
          <Box alignItems="right" justifyContent={ isMobile ? "flex-start" : "flex-end" } display="flex">
            <a
                href={playlist.is_custom ? `/app/twi/mylist/${playlist.uniqid}` : playlist.permalinks?.web} className="video-group-link"
            >
            <Typography variant="subtitle1" component="div" className="video-group-count" sx={{color: 'white'}}>
              {playlist.video_count} {playlist.video_count === 1 ? __('Item') : __('Items')}
              &nbsp;
              { playlist?.asset_type?.includes('Audio') && <MusicVideoIcon sx={{ml: 0.5}} /> }
              { playlist?.asset_type?.includes('Video') && <OndemandVideoIcon sx={{ml: 0.5}} /> }
            </Typography>
            </a>
          </Box>
          </Grid>
          </Grid>
        }

      <div className="video-main-content">

      {isMobile ? (
        <>
        {
          playlist?.uniqid ? (
            <Typography variant="h2" component="h2" className="video-info__title video-title-mobile">
              {video.name}
            </Typography>
          ) : (
            <Typography variant="h1" component="h1" className="video-info__title video-title-mobile">
              {video.name}
            </Typography>
          )
        }

    <div className="video-player">
      <PlayerSection
        video={video}
        playlist={playlist}
        playlistAcl = {playlistAcl}
        usePlaylistOverride={usePlaylistOverride}
        video_time={props.videoData.video_time}
        brightcoveConfig={props.brightcoveConfig}
        restricted={restricted}
        block_message={block_message}
        usage_type_link={usage_type_link}
        usage_type_message={usage_type_message}
        cta_kind={cta_kind}
        app_link={app_link}
        app_button_title={app_button_title}
        autoplay={autoplay}
        shuffle={shuffle}
        repeat={repeat}
        setCountdown={setCountdown}
        setShowOverlay={setShowOverlay}
        countdown={countdown}
        showOverlay={showOverlay}
        loading={loading}
        error={error}
        setError={setError}
        setLoading={setLoading}
        navigate={navigate}
        relatedVideos={autoplayVideos}
        logged_in={logged_in}
        activeTab={activeTab}
        svod_subscription={Boolean(svod_subscription)}
      />

      <VideoControlsPanel
        isplaylistContext={playlistVideosIndex !== -1}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        autoplay={autoplay}
        shuffle={shuffle}
        repeat={repeat}
        setAutoplay={setAutoplay}
        setShuffle={setShuffle}
        setRepeat={setRepeat}
      />

    </div>


    <div className="video-info video-info-mobile">

      {!isMobile && (
        <div className="video-controls-toggles">
          <span className="video-toggle-label">{__('AUTO PLAY')}</span>
          <label className="video-toggle-switch">
            <input
              type="checkbox"
              checked={autoplay}
              onChange={(e) => setAutoplay(e.target.checked)}
            />
            <span className="slider"></span>
          </label>

          <span className="video-toggle-label">{__('REPEAT')}</span>
          <label className="video-toggle-switch">
            <input
              type="checkbox"
              checked={repeat}
              onChange={(e) => setRepeat(e.target.checked)}
            />
            <span className="slider"></span>
          </label>
          <span className="video-toggle-label">{__('SHUFFLE')}</span>
          <label className="video-toggle-switch">
            <input
              type="checkbox"
              checked={shuffle}
              onChange={(e) => {
                const checked = e.target.checked;
                setShuffle(checked);
                if (checked && !autoplay) {
                  setAutoplay(true);
                }
              }}
            />
            <span className="slider"></span>
          </label>
            </div>
          )}

      {/* badges */}
      <div className="video-info__badges">
                <div className="video-card__badges">
                  {isVideo && <span className="video-card__badge">{__('VIDEO')}</span>}
                  {isAudio && <span className="video-card__badge">{__('AUDIO')}</span>}
                  {isPersonal && <PersonalUseBadge coachmark />}
                  {isMinister && <span className="video-card__badge video-card__badge--minister">{__('MINISTER')}</span>}
                  {isInitiate && <span className="video-card__badge video-card__badge--initiate">{__('INITIATE')}</span>}
                  {isSatSubscriber && <span className="video-card__badge video-card__badge--sat">{__('SAT SUBSCRIBER')}</span>}
                  {isDiscourse && <span className="video-card__badge video-card__badge--discourse">{__('DISCOURSE')}</span>}
                  {isPremium && (
                    <span className="video-card__badge video-card__badge--premium" style={{ marginLeft: 'auto' }}>{__('PREMIUM')}</span>
                  )}
                </div>
      </div>


      {/* duration */}
      <p className="video-info__duration">{__('Duration')}: {formatDuration(video.duration)}</p>

      {/* description */}
      <div className="video-info__description">
      <div
        className="video-info__description"
        dangerouslySetInnerHTML={{
          __html: showMore ? description : truncatedDescription
        }}
      />
      {description.length > 200 && (
        <button className="video-info__more-button" onClick={() => setShowMore(!showMore)}>
          {showMore ? __('LESS') : __('MORE')}
        </button>
      )}
  </div>

 
    {!restricted && (
      <div className="video-info__actions">
        <a
          onClick={(e) => {
            e.preventDefault();
            setShowPlaylistModal(true);
          }}
          className={`action-button ${mylist_already_exists ? 'action-button--disabled' : ''}`}
        >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="12" y1="5" x2="12" y2="19"></line>
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                </svg>
          {mylist_already_exists ? __('Added to My List') : __('Add to My List')} 
        </a>

        {playlistFeedback && (
      <div className="group-feedback">{playlistFeedback}</div>
    )}
      </div>
    )}


      {/* tags */}
      {video.tags && (
        <div className="video-tags">
          <strong>{__('Tags')}:</strong>
          {Object.keys(video.tags).map((uniqid, idx) => {
            let tag = video.tags[uniqid];
            let tagUrl = `/app/twi/results?c=${encodeURIComponent(uniqid)}`;
            return (
              <a key={'tag-' + idx} href={tagUrl} className="tag-link" aria-description={tag}>
                {tag}
              </a>
            );
          })}
        </div>
      )}

      {/* playlists */}
      {playlists?.length > 0 && (
        <div className="video-playlists">
          <strong>{__('Playlists')}:</strong>
          {playlists.map((playlist, index) => {
            let playlistUrl = `/app/twi/playlist/${encodeURIComponent(playlist.uniqid)}`;
            return (
              <a key={'playlist-' + index} href={playlistUrl} className="group-link">
                {playlist.name}
              </a>
            );
          })}
        </div>
      )}

      {/* mylists */}
      {mylists?.length > 0 && (
        <div className="video-playlists">
          <strong>{__('My Lists')}:</strong>
          {mylists.map((mylist, index) => {
            let mylistUrl = `/app/twi/mylist/${encodeURIComponent(mylist.uniqid)}`;
            return (
              <a key={'mylist-' + index} href={mylistUrl} className="group-link">
                {mylist.name}
              </a>
            );
          })}
        </div>
      )}

      {/* last seen */}
      {video.last_viewed && (
        <p className="video-info__last-seen">
          <strong>{__('Video Last Seen')}:</strong> {video.last_viewed}
        </p>
      )}
    </div>
  </>
) : (
        <div className="video-content">
          <div className="video-info">
            {
            playlist?.uniqid ?
              (
                  <Typography variant="h2" component="h2" className="video-info__title text-uppercase">
                    {video.name}
                  </Typography>
              ) : (
                  <Typography variant="h1" component="h1" className="video-info__title text-uppercase">
                    {video.name}
                  </Typography>
              )
            }

            <div className="video-info__badges">
                <div className="video-card__badges">
                  {isVideo && <span className="video-card__badge">{__('VIDEO')}</span>}
                  {isAudio && <span className="video-card__badge">{__('AUDIO')}</span>}
                  {isPersonal && <PersonalUseBadge coachmark />}
                  {isMinister && <span className="video-card__badge video-card__badge--minister">{__('MINISTER')}</span>}
                  {isInitiate && <span className="video-card__badge video-card__badge--initiate">{__('INITIATE')}</span>}
                  {isSatSubscriber && <span className="video-card__badge video-card__badge--sat">{__('SAT SUBSCRIBER')}</span>}
                  {isDiscourse && <span className="video-card__badge video-card__badge--discourse">{__('DISCOURSE')}</span>}
                  {isPremium && (
                    <span className="video-card__badge video-card__badge--premium" style={{ marginLeft: 'auto' }}>{__('PREMIUM')}</span>
                  )}
                </div>
            </div>

            <p className="video-info__duration">{__('Duration')}: {formatDuration(video.duration)}</p>
            
              <div className="video-info__description">
                <div
                  dangerouslySetInnerHTML={{
                    __html: showMore ? description : truncatedDescription
                  }}
                />
                {description.length > 200 && (
                  <button className="video-info__more-button" onClick={() => setShowMore(!showMore)}>
                    {showMore ? __('LESS') : __('MORE')}
                  </button>
                )}
              </div>
{!restricted && (
  <div className="video-info__actions">
    {mylist_already_exists ? (
      <div className="action-message">
         {__('This video is already in your playlist.')}
      </div>
    ) : (
      <>
        <a
          onClick={(e) => {
            e.preventDefault();
            setShowPlaylistModal(true);
          }}
          className="action-button"
        >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="12" y1="5" x2="12" y2="19"></line>
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                  </svg>
          {__('Add to My List')}
        </a>
{playlistFeedback && (
  <div className="group-feedback">{playlistFeedback}</div>
)}

      </>
    )}
  </div>
)}


  {video?.meta?.handouts?.length > 0 && (
  <div className="video-handouts">
    <h3>{__('Handouts')}</h3>
    <div className="video-handouts__list">
      {video.meta.handouts.map((handout, index) => (
        <a
          key={index}
          href={handout.url}
          target="_blank"
          rel="noopener noreferrer"
          className="video-handouts__item"
        >
          <i className="fa fa-file-text" aria-hidden="true"></i>
          <span className="video-handouts__name">{handout.name}</span>
        </a>
      ))}
    </div>
  </div>
)}

            {video.tags && (
              <div className="video-tags">
                <strong>{__('Tags')}:</strong>
                {Object.keys(video.tags).map((uniqid, idx) => {
                  let tag = video.tags[uniqid];
                  let tagUrl = `/app/twi/results?c=${encodeURIComponent(uniqid)}`;
                  return (
                    <a
                      key={idx}
                      href={tagUrl}
                      className="tag-link"
                      aria-description={tag}
                    >
                      {tag}
                    </a>
                  );
                })}
              </div>
            )}

            {/* playlists */}
            {playlists?.length > 0 && (
              <div className="video-playlists">
                <strong>{__('Playlists')}:</strong>
                {playlists.map((pl, index) => {
                  let playlistUrl = `/app/twi/playlist/${encodeURIComponent(pl.uniqid)}`;
                  return (
                    <a key={index} href={playlistUrl} className="group-link">
                      {pl.name || pl.title}
                    </a>
                  );
                })}
              </div>
            )}

            {/* mylists */}
            {mylists?.length > 0 && (
              <div className="video-playlists">
                <strong>{__('My Lists')}:</strong>
                {mylists.map((mylist, index) => {
                  let mylistUrl = `/app/twi/mylist/${encodeURIComponent(mylist.uniqid)}`;
                  return (
                    <a key={'mylist-' + index} href={mylistUrl} className="group-link">
                      {mylist.name || mylist.title}
                    </a>
                  );
                })}
              </div>
            )}

            {video.video_last_seen && (
              <p className="video-info__last-seen">
                <strong>{__('Video Last Seen')}:</strong> {video.video_last_seen}
              </p>
            )}
          </div>

          <div className="video-player">
            <PlayerSection
              video={video}
              playlist={playlist}
              playlistAcl = {playlistAcl}
              usePlaylistOverride={usePlaylistOverride}
              video_time={props.videoData.video_time}
              brightcoveConfig={props.brightcoveConfig}
              restricted={restricted}
              block_message={block_message}
              usage_type_link={usage_type_link}
              usage_type_message={usage_type_message}
              cta_kind={cta_kind}
              app_link={app_link}
              app_button_title={app_button_title}
              autoplay={autoplay}
              shuffle={shuffle}
              repeat={repeat}
              setCountdown={setCountdown}
              setShowOverlay={setShowOverlay}
              countdown={countdown}
              showOverlay={showOverlay}
              loading={loading}
              error={error}
              setError={setError}
              setLoading={setLoading}
              navigate={navigate}
              relatedVideos={autoplayVideos}
              logged_in={logged_in}
              activeTab={activeTab}
              svod_subscription={!!svod_subscription}
            />
          </div>
        </div>
)}

{showPlaylistModal && video?.id && (
  <PlaylistModal
    videoId={video.id}
    onClose={() => setShowPlaylistModal(false)}
    onResult={(message) => setPlaylistFeedback(message)} 
  />
)}
{isMobile && (
  <div className="video-controls-toggles">
    <span className="video-toggle-label">{__('AUTO PLAY')}</span>
    <label className="video-toggle-switch">
      <input
        type="checkbox"
        checked={autoplay}
        onChange={(e) => setAutoplay(e.target.checked)}
      />
      <span className="slider"></span>
    </label>

    <span className="video-toggle-label">{__('REPEAT')}</span>
    <label className="video-toggle-switch">
      <input
        type="checkbox"
        checked={repeat}
        onChange={(e) => setRepeat(e.target.checked)}
      />
      <span className="slider"></span>
    </label>

<span className="video-toggle-label">{__('SHUFFLE')}</span>
<label className="video-toggle-switch">
  <input
    type="checkbox"
    checked={shuffle}
    onChange={(e) => {
      const checked = e.target.checked;
      setShuffle(checked);
      if (checked && !autoplay) {
        setAutoplay(true);
      }
    }}
  />
  <span className="slider"></span>
</label>
  </div>
   
)} 


{(
  ['Personal', 'Personal Use', 'Minister', 'Initiate', 'SAT', 'Minister or Initiate', 'Minster or Initiate'].includes(video?.usage_type)
  && !hidePersonalBanner
) && (
  <div className="personal-banner-container" id="personal-banner-container">
    <div className="personal-banner">
      <div className="banner-content">
        <div className="banner-icon">
          <i className="fa fa-bell fa-3x" />
        </div> 
        <div className="banner-text">
          {__('This content is for personal use only.')}{' '}
          <a href={__('https://www.msia.org/customer-center-usage-guidelines')} target="_blank" rel="noopener noreferrer">
            {__('Click here')}
          </a>{' '}
          {__('to learn more about personal use video.')}

          {is_seminar_leader && (
            ['Minister', 'Initiate', 'SAT', 'Minister or Initiate', 'Minster or Initiate'].includes(video?.usage_type) && (
              <div style={{ marginTop: '6px' }}>
                <span style={{
                  backgroundColor: '#333',
                  color: '#fff',
                  padding: '6px 10px',
                  borderRadius: '4px',
                  display: 'inline-block',
                  fontSize: '1.075rem',
                  fontWeight: 600,
                }}>
                  {__('Not approved for seminar use.')}
                </span>
              </div>
            )
          )}
        </div>
        <div className="banner-dismiss" onClick={() => setHidePersonalBanner(true)}>
          {__('Dismiss')}
        </div>
      </div>
    </div>
  </div>
)}





  <>
    <VideoControlsPanel
      isPlaylistContext={isInPlaylistContext}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      autoplay={autoplay}
      shuffle={shuffle}
      repeat={repeat}
      setAutoplay={setAutoplay}
      setShuffle={setShuffle}
      setRepeat={setRepeat}
      isMobile={isMobile}
    />

    {activeTab === 'recommended' ? (
      <RelatedRecommendedVideos
        activeTab={activeTab}
        recommendedVideos={recommendedVideos}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        title={__('Recommended Content')}
        autoplayIndex={autoplayIndex}
      />
    ) : (
      (playlistVideosIndex == -1) && (
      <RelatedRecommendedVideos
        activeTab={activeTab}
        relatedVideos={relatedVideos}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        title={related_videos_display_title}
        autoplayIndex={autoplayIndex}
      />
      )
    )}
  </>



      </div>
    </div>
  );
};

const formatDuration = (duration) => {
  if (!duration) return '';
  const milliseconds = typeof duration === 'string' ? parseInt(duration, 10) : duration;
  if (isNaN(milliseconds)) return '';
  const seconds = Math.round(milliseconds / 1000);
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;
  return hours > 0
    ? `${hours}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`
    : `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};

export default ShowVideoOrPlaylist;